import Jsona from 'jsona';

import { get } from 'lodash';

export const strict = false;

// type
export const type = 'demo-template-routing';

// getters
export const ROUTING = 'ROUTING';
export const ROUTING_QUESTIONS = 'ROUTING_QUESTIONS';

// mutations
const SET_DEMO_TEMPLATE_ROUTING = 'SET_DEMO_TEMPLATE_ROUTING';
const SET_DEMO_TEMPLATE_ROUTING_QUESTIONS = 'SET_DEMO_TEMPLATE_ROUTING_QUESTIONS';

// actions
export const GET = 'GET';
export const GET_REDIRECT_URL = 'GET_REDIRECT_URL';

const REQUEST_PATH = 'api/v1/demo_template_routings';

export const state = () => ({
  routing: {},
  routingQuestions: []
});

export const getters = {
  [ROUTING]: state => state.routing,
  [ROUTING_QUESTIONS]: state => state.routingQuestions
};

export const mutations = {
  [SET_DEMO_TEMPLATE_ROUTING](state, payload) {
    state.routing = payload;
  },

  [SET_DEMO_TEMPLATE_ROUTING_QUESTIONS](state, payload) {
    state.routingQuestions = payload;
  }
};

export const actions = {
  async [GET]({ commit }, { slug, demoTemplateRoutingSlug }) {
    try {
      const url = `${REQUEST_PATH}/info`;

      const params = { slug, id: demoTemplateRoutingSlug };

      const response = await this.$axios.$get(url, { params });

      const deserializedData = new Jsona().deserialize(response);
      const { routingQuestions } = deserializedData;

      commit(SET_DEMO_TEMPLATE_ROUTING, deserializedData);

      commit(SET_DEMO_TEMPLATE_ROUTING_QUESTIONS, routingQuestions);
    } catch (error) {
      if (get(error, ['response', 'status']) === 404) {
        const errorRedirectURL = `/select/not-found/${slug}/${demoTemplateRoutingSlug}${window.location.search}`;

        this.$router.push({ path: errorRedirectURL });
      } else {
        this.$sentry.captureException(error);

        console.error('caught', error);
      }
    }
  },

  async [GET_REDIRECT_URL](_, { slug, demoTemplateRoutingSlug, jsonLogicVariables }) {
    try {
      const url = `${REQUEST_PATH}/${demoTemplateRoutingSlug}/redirect_url`;

      const params = {
        params: {
          slug,
          json_logic_variables: jsonLogicVariables
        }
      };

      const response = await this.$axios.$get(url, params);

      const redirectURL = response.data.url;

      return redirectURL;
    } catch (error) {
      console.error('caught', error);
    }

    return false;
  }
};
